export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            欢迎投稿、爆料或商务合作，吃瓜网站线路一期待与您交流
          </p>
        </div>

        <div className="max-w-lg mx-auto">
          <div className="bg-background-50 rounded-2xl p-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <a
                href="#contact"
                className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 hover:bg-background-200 transition-colors cursor-pointer group"
              >
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                  <i className="ri-mail-line text-xl text-primary-600 group-hover:text-white transition-colors"></i>
                </div>
                <span className="text-sm font-medium text-foreground-800">投稿爆料</span>
                <span className="text-xs text-foreground-500">tg@example</span>
              </a>

              <a
                href="#contact"
                className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 hover:bg-background-200 transition-colors cursor-pointer group"
              >
                <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center group-hover:bg-accent-500 transition-colors">
                  <i className="ri-briefcase-line text-xl text-accent-600 group-hover:text-white transition-colors"></i>
                </div>
                <span className="text-sm font-medium text-foreground-800">商务合作</span>
                <span className="text-xs text-foreground-500">bd@example</span>
              </a>

              <a
                href="#contact"
                className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 hover:bg-background-200 transition-colors cursor-pointer group"
              >
                <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center group-hover:bg-secondary-500 transition-colors">
                  <i className="ri-wechat-line text-xl text-secondary-600 group-hover:text-white transition-colors"></i>
                </div>
                <span className="text-sm font-medium text-foreground-800">微信联系</span>
                <span className="text-xs text-foreground-500">chigua51</span>
              </a>

              <a
                href="#contact"
                className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 hover:bg-background-200 transition-colors cursor-pointer group"
              >
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                  <i className="ri-user-add-line text-xl text-primary-600 group-hover:text-white transition-colors"></i>
                </div>
                <span className="text-sm font-medium text-foreground-800">人才招聘</span>
                <span className="text-xs text-foreground-500">hr@example</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}